'use strict';

/**
 * Service: Storage
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdStorageService for ES6 usage
 *          3.2.0 #261 Unit Test Coverage, Tidy
 *          3.0.0 #249 Refactor wdStorageService versioning
 *          3.0.0 #236 Add Shared Functionality to Main Library
 *
 * INSTALL:
 *
 * Add to index.html:
 *
 * <script src="bower_components/main-library-js/lib/angularjs/helpers/wdHashHelper.js"></script>
 * <script src="bower_components/main-library-js/lib/angularjs/services/wdStorage.js"></script>
 * <script src="bower_components/main-library-js/lib/webduct/hash/AdapterHash.js"></script>
 * <script src="bower_components/jsSHA/src/sha.js"></script>
 *
 * Add to bower dependencies and then run 'bower install':
 *
 * "jsSHA": "~2.0.0"
 *
 * Add to app.js:
 *
 *         'wd.helper.hash',
 *         'wd.storage'
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2015-2020 Build Centrix
 */
var wdStorageService = angular.module('wd.storage',[])
    .factory(
    'wdStorageService', [
        'wdHashHelper',

        function (wdHashHelper)
        {
            var service = {};

            var isInitialized = false;
            var prefix = 'wd.';

            /**
             * Return the Local Storage Path
             *
             * @since 5.0.1
             * @param name
             * @returns {string}
             */
            service.getPath = function(name) {

                return prefix + name;

            };

            /**
             * Initialize the service
             *
             * @since 1.4.0
             */
            service.initialize = function ()
            {

                var result = true;

                isInitialized = true;

                return result;

            };

            /**
             * Initialise Local Storage
             *
             * @since 3.0.0
             */
            service.initializeDefaults = function (name, configuration)
            {

                //Initialize
                service.initialize();

                var configurationHash = wdHashHelper.getHash(JSON.stringify(configuration));
                var localConfigurationHash = service.getLocalStorageHash(name);

                //console.log(configurationHash);
                //console.log(localConfigurationHash);

                if (configurationHash === localConfigurationHash) { //We already have local storage

                    service[name] = {};

                    //Get all saved default values
                    service[name] = service.loadLocalStorageConfiguration(name, configuration);

                } else { //If the version in local storage version does not exist or is not up to date

                    //console.log('clearing storage');

                    configuration.hash = configurationHash;

                    //Remove all saved values
                    service.clearStorage(name);

                    //Set all options to default values
                    service.saveLocalStorageConfiguration(name, configuration);

                }

                return service;

            };

            /**
             * Remove localStorage Items
             *
             * @since 1.4.0
             */
            service.clearStorage = function (name)
            {

                var result = true;

                /* istanbul ignore else */
                if (isInitialized) {

                    localStorage.removeItem(service.getPath(name));

                }

                return result;

            };

            /**
             * Get a storage value by key
             *
             * @since 1.4.0
             * @param name
             * @param key
             * @returns {*}
             */
            service.getItem = function (name, key)
            {

                //initialise result
                var result;

                if (isInitialized) {

                    // Get requested data from local storage
                    var unparsedData = localStorage.getItem(service.getPath(name));

                    //Parsed Data Object
                    var parsedData = {};

                    // If localStorage exists, parse result
                    if (unparsedData !== null) {

                        parsedData = JSON.parse(unparsedData);

                    }

                    result = parsedData[key];

                }

                // Return the result
                return result;

            };

            /**
             * Set a storage key/value pair
             *
             * @since 1.4.5
             * @param name
             * @param key
             * @param value
             */
            service.setItem = function (name, key, value)
            {

                var result = true;

                if (isInitialized) {

                    // Get requested data from local storage
                    var unparsedData = localStorage.getItem(service.getPath(name));

                    //Parsed Data Object
                    var parsedData = {};

                    // If localStorage exists, parse result
                    if (unparsedData !== null) {

                        parsedData = JSON.parse(unparsedData);

                    }

                    localStorage.removeItem(service.getPath(name));

                    parsedData[key] = value;

                    localStorage.setItem(service.getPath(name), JSON.stringify(parsedData));

                }

                return result;

            };

            /**
             * Load saved values based on their default configuration key values
             *
             * @since 1.4.0
             * @param name
             * @param configuration
             * @returns {{}}
             */
            service.loadLocalStorageConfiguration = function (name, configuration)
            {

                var results = {};

                // Visit non-inherited enumerable keys
                Object.keys(configuration).forEach(
                    function (key)
                    {

                        results[key] = service.getItem(name, key);

                    }
                );

                return results;

            };

            /**
             * Save a configuration to local storage and set new version
             *
             * @since 1.4.5
             * @param name
             * @param configuration
             * @returns {boolean}
             */
            service.saveLocalStorageConfiguration = function (name, configuration)
            {

                var result = true;

                // Visit non-inherited enumerable keys
                Object.keys(configuration).forEach(
                    function (key)
                    {

                        service.setItem(name, key, configuration[key]);

                    }
                );

                service[name] = configuration;

                return result;

            };

            /**
             * Get localStorage Version
             *
             * @since 1.4.0
             * @returns {*}
             */
            service.getLocalStorageHash = function (name)
            {

                var result;

                result = service.getItem(name, 'hash');

                return result;

            };

            return service;
        }

    ]
);
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdStorageService;
}
// EOF
